module.exports = __webpack_public_path__ + "siteminder.png?00a8782f45a51020458b43d6bb2a8f6a";